import { render, staticRenderFns } from "./SubventionenReiter.vue?vue&type=template&id=c1e5114a"
import script from "./SubventionenReiter.vue?vue&type=script&lang=js"
export * from "./SubventionenReiter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports